<template>
<div>
  <common-header></common-header>
  <div class="internetCourt">
    <div class="interbanimg">
      <pub-animate>
        <div class="bannerContent" v-show="showNavPic">
                   <div :class="$route.path.indexOf('en')==1?'banner-en':'banner-title'">
                   </div>
          <div class="right banner-layer layer2"  :class="{move:startMove}">
            <img v-if="$route.path.indexOf('en')==-1" src="~img/internetCourt/zt_banner_img.png"/>
            <img v-else src="~img/internetCourt/banner/en/ring_img.png"/>
            <img class="endGz" v-if="$route.path.indexOf('en')==-1" src="~img/internetCourt/banner/gocourt_img.png"/>
            <img class="endGz" v-else src="~img/internetCourt/banner/en/gocourt_img.png"/>
             <div class="bannerTab">
                <img class="none bannerTab1 thisSrc" v-if="$route.path.indexOf('en')==-1" src="../../assets/images/internetCourt/banner/notary_nor_img.png"/>
                   <img class="none bannerTab1 thisSrc" v-else src="../../assets/images/internetCourt/banner/en/notary_nor_img.png"/>
                <img class="block bannerTab1 itemSrc1" v-if="$route.path.indexOf('en')==-1" src="../../assets/images/internetCourt/banner/notary_hov_pre_img.png"/>
                  <img class="block bannerTab1 itemSrc1" v-else src="../../assets/images/internetCourt/banner/en/notary_hov_pre_img.png"/>
                <canvas v-if="flag" class="animaationBox1" id="myCanvas" width="390px" height="390px"></canvas>
             </div>
            <div class="bannerTab">
                <img class="block bannerTab2 thisSrc"  v-if="$route.path.indexOf('en')==-1" src="../../assets/images/internetCourt/banner/legal_nor_img.png"/>
                 <img class="block bannerTab2 thisSrc"  v-else src="../../assets/images/internetCourt/banner/en/legal_nor_img.png"/>
                <img class="none bannerTab2 itemSrc2" v-if="$route.path.indexOf('en')==-1" src="../../assets/images/internetCourt/banner/legal_hov_pre_img.png"/>
                  <img class="none bannerTab2 itemSrc2" v-else src="../../assets/images/internetCourt/banner/en/legal_hov_pre_img.png"/>
                <canvas v-if="!flag" class="animaationBox1" id="myCanvas1" width="390px" height="390px"></canvas>
             </div>
          </div>
        </div>
      </pub-animate>

    </div>
    <procedure :info="lanInfo.procedure"></procedure>
    <fast-entry :info="lanInfo.fastEntry"></fast-entry>
  </div>
  </div>
</template>

<script>
import procedure from './procedure.vue';
import fastEntry from './fastEntry.vue';
// import inBanner from "../common/inbanner"
import { mapGetters } from "vuex";
import $ from "jquery"
export default {
  data() {
    return {
      showNavPic: false,
      tabhead: ["北京互联网法院", "杭州互联网法院", "广州互联网法院"],
      itemCon: [],
      oneDeg:1.1,
      twoDeg:1.1,
      flag:false,
      bannerList:[{
        itemSrc:"",}],
      num: 0,
      startMove: false,
      downloadshow: true
    };
  },
  components: {
    procedure,
    fastEntry
    // inBanner
  },
  mounted() {
    setTimeout(() => {
      this.startMove = true;
    }, 200);
    setTimeout(() => {
      this.showNavPic = true;
    }, 100);
    this.changeBanner()
  },
  methods: {
    goclick() {
      this.$router.push({ path: "/user/register" });
    },
    golink(e) {
      window.open(e);
    },
    changeBanner(){
      var that=this;
        $(".thisSrc").hover(function(){
           that.oneDeg=1.1;
          that.twoDeg=1.1;
           that.arc()
           $(".thisSrc").addClass("block").removeClass("none")
          $(".thisSrc").next().next().addClass("none").removeClass("block")
          $(".thisSrc").next().removeClass("block").addClass("none")
          $(this).next().addClass("block").removeClass("none")
           $(this).removeClass("block").addClass("none")
           $(this).next().next().addClass("block").removeClass("none")
            $(this).next().next().css({'width':"390px"})
             if($(this).hasClass("bannerTab1")){
                 that.flag=true;
                let times=setInterval(() => {
                 that.oneDeg+=0.1;
                if(that.oneDeg>=1.9){
                  that.oneDeg=1.9
                  clearInterval(times)
                }
                that.arc() }, 100);
             }else{
               that.flag=false;
               let times=setInterval(() => {
                that.twoDeg+=0.1;
                if(that.twoDeg>=1.9){
                  that.twoDeg=1.9
                  clearInterval(times)
                }
                that.arc()}, 100);
             }
        })
    },
    arc(){
      if(this.flag){
         var canvas = document.getElementById("myCanvas");
          if(canvas.getContext){  
              //获取对应的CanvasRenderingContext2D对象(画笔)
              var ctx = canvas.getContext("2d");  
              //开始一个新的绘制路径
              ctx.beginPath();
              //设置弧线的颜色为蓝色
              ctx.strokeStyle = "#AA1125";
              ctx.lineWidth=2;
              var circle = {
                  x : 200,    //圆心的x轴坐标值
                  y : 200,    //圆心的y轴坐标值
                  r : 198        //圆的半径
              };
              //沿着坐标点(100,100)为圆心、半径为50px的圆的顺时针方向绘制弧线
              ctx.arc(circle.x, circle.y, circle.r,2.87, this.oneDeg*Math.PI);    
              //按照指定的路径绘制弧线
              ctx.stroke();
              ctx.clearRect(200,200,390,390);  
          }
      }else{
          var canvas = document.getElementById("myCanvas1");
          if(canvas.getContext){  
              //获取对应的CanvasRenderingContext2D对象(画笔)
              var ctx = canvas.getContext("2d");  
              //开始一个新的绘制路径
              ctx.beginPath();
              //设置弧线的颜色为蓝色
              ctx.strokeStyle = "#AA1125";
              ctx.lineWidth=2;
              var circle = {
                  x : 200,    //圆心的x轴坐标值
                  y : 200,    //圆心的y轴坐标值
                  r : 198        //圆的半径
              };
              //沿着坐标点(100,100)为圆心、半径为50px的圆的顺时针方向绘制弧线
              ctx.arc(circle.x, circle.y, circle.r, 3.284,this.twoDeg*Math.PI);    
              //按照指定的路径绘制弧线
              ctx.stroke();
               ctx.stroke();
          }
    }
      }

  },
  computed: {
    ...mapGetters(['getLanInfo']),
    lanInfo() {
      return this.getLanInfo.internetCourt
    }
  },
};
</script>

<style scoped  lang="scss">
.internetCourt {
  width: 100%;
  position: relative;
  z-index: 0;
}
.interbanimg {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 560px;
  background: url("~img/internetCourt/hlwfy_banner_bg_img.png") center no-repeat;
  background-size: 100% 100%;
  .bannerContent {
      position: relative;
      width: 1200px;
      margin: 0 auto;
      height: 560px;
      .left {
        position: absolute;
        left: 50%;
        bottom: 44px;
        transform: translateX(-50%);
        width: 893px;
        height: 56px;
      } .banner-title{
            width: 805px;
            height: 57px;
            position: absolute;
            top: 6.8%;
            left: 50%;
            margin-left: -402px;
            background: url("~img/internetCourt/title_img.png");
            background-size: 80% 80%;
            background-position:center center;
            background-repeat: no-repeat;
          }
          .banner-en{
            width: 870px;
            height: 50px;
            position: absolute;
            top: 6.8%;
            left: 50%;
            margin-left: -435px;
            background: url("../../assets/images/internetCourt/banner/title_img.png");
            background-size: 80% 80%;
            background-position:center center;
            background-repeat: no-repeat;
          }
          .banner-layer{
              opacity: 0;
              -webkit-transition: all 1.5s ease-in-out 0s;
              -o-transition: all 1.5s ease-in-out 0s;
              -moz-transition: all 1.5s ease-in-out 0s;
              transition: all 1.5s ease-in-out 0s;
          }
          .banner-layer.layer2.move{
            opacity: 1;
             top: 83px;
          }

      .right {
          position: absolute;
          top: 83px;
          left: 59%;
          -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
          width: 863px;
          height: 420px;
         
          .endGz{
            position: absolute;
            right: -10.1%;
            top: 16%;
          }
          .bannerTab1{
            position: absolute;
            top: 62%;
            left: -4.5%;
            cursor: pointer;
            z-index: 9;
          }
          .bannerTab2{
            position: absolute;
            top: 39%;
            left: -4.75%;
            cursor: pointer;
            z-index: 9;
          }
          .block{
            display: block;
          }
          .none{
            display: none;
          }
          .itemSrc2{
            position: absolute;
            top: 14.5%;
            left: -30.5%;
            z-index: 1;
          }
          .itemSrc1{
            position: absolute;
            top: 40%;
            left: -30.5%;
            z-index: 1;
          }
           .animaationBox1{
            //  width: 300px;
            //  height: 396px;
            //  border-radius: 50%;
            //  border:2px solid #AA1125;
             position: absolute;
             top: 8%;
              left: 14.2%;
              z-index: 1;
             transition: width 0.7s ease-in-out 0s;
             transform: rotate(4.5deg)
           }
      }
    }
}
</style>